var _rect, _circle, _path, _circle2, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffreshIconSummary4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 29.0031,
    r: 6,
    fill: "#D1DDFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 49.8928C65 56.7065 39 56.7065 39 49.8928C39 43.0791 44.8203 35.0031 52 35.0031C59.1797 35.0031 65 43.0791 65 49.8928Z",
    fill: "#D1DDFB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30.0031,
    r: 7,
    fill: "#A8B1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56.3597C49 65.2175 19 65.2175 19 56.3597C19 47.502 25.7157 37.0031 34 37.0031C42.2843 37.0031 49 47.502 49 56.3597Z",
    fill: "#A8B1CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#F2F4FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffreshIconSummary4);
export default __webpack_public_path__ + "static/media/offresh_icon-summary4.cc392119eaa76f6698e499325c6c6fc6.svg";
export { ForwardRef as ReactComponent };